export default function UnknownPage() {
    return (
      <h2>Page not found.</h2>
    )
}